var map = {
	"./IMG_0148.jpeg": 7810,
	"./IMG_0161.jpeg": 2761,
	"./IMG_0163.jpeg": 9245,
	"./IMG_0170.jpeg": 1678,
	"./IMG_0196.jpeg": 6613,
	"./IMG_1539.jpeg": 9470,
	"./IMG_1540.jpeg": 6181,
	"./IMG_1541.jpeg": 7116,
	"./IMG_1559.jpeg": 1094,
	"./IMG_1561.jpeg": 9584,
	"./kitch3.b2001028.png": 4841,
	"./kitch4.a0a57d97.png": 8868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8472;